<template>
  <div id="header">
    <div id="header-area">
      <router-link to="/" class="home-link" aria-label="Breezer 홈">
        <span class="brand-mark" aria-hidden="true">
          <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round">
            <path d="M3 8h11a3 3 0 1 0-3-3" />
            <path d="M3 12h15a3 3 0 1 1-3 3" />
            <path d="M3 16h9" />
          </svg>
        </span>
        <span class="brand-word">breez<b>er</b></span>
      </router-link>
      <div id="service-area">
        <template v-for="(service, index) in services" :key="index">
          <a
            v-if="service.external"
            :href="service.path"
            class="service"
          >
            <div class="label">{{ service.name }}</div>
          </a>
          <router-link v-else :to="service.path" class="service">
            <div class="label">{{ service.name }}</div>
          </router-link>
        </template>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted } from "vue";

import serviceMenu from "@/common/assets/json/service.json";
import * as core from "@/common/utils/core";

interface ServiceItem {
  name: string;
  path: string;
  external?: boolean;
}

export default defineComponent({
  name: "HeaderComponent",
  setup() {
    const serviceInfo = ref<{
      serviceInfo: ServiceItem[];
    }>(serviceMenu);

    // 컴포넌트가 마운트되면 데이터를 로드합니다.
    onMounted(() => {
      // 여기에서 추가적인 초기화 작업을 할 수 있습니다.
    });

    return {
      serviceInfo,
    };
  },
  computed: {
    services(): ServiceItem[] {
      const list: ServiceItem[] = [...this.serviceInfo.serviceInfo];
      const loginInfo = core.getLoginInfo();

      // 키워드는 홈이 서비스 소개라 메뉴는 모두에게 보인다.
      // 비로그인 = 소개 화면, 로그인 = 조회 도구.
      // 실제 사용 가능 여부는 서버가 tb_service_setting 으로 판정한다
      // (전체 공개 / 권한자만 / 점검 중 — 관리 > 서비스관리에서 실시간 변경).
      //
      // 위치는 부동산 바로 오른쪽. service.json 에 넣지 않고 여기서 끼우는 이유는
      // 로그인 상태에 따라 다르게 다룰 여지를 남겨 두기 위해서다.
      const aptIndex = list.findIndex((s) => s.path === "/apt");
      const keyword = { name: "키워드", path: "/keyword" };
      if (aptIndex >= 0) {
        list.splice(aptIndex + 1, 0, keyword);
      } else {
        list.push(keyword);
      }

      // 관리자에게만 관리 메뉴 노출
      if (loginInfo && loginInfo.role === "ROLE_ADMIN") {
        list.push({ name: "관리", path: "/admin" });
      }
      return list;
    },
  },
});
</script>
